export default {

  // 新增标书管理
  insertYcBidDocument: '/ygsjzs/ycBidDocument/insertYcBidDocument',
  // 修改标书管理
  updateYcBidDocument: '/ygsjzs/ycBidDocument/updateYcBidDocument',
  // 中标生成采购订单/废标
  addYcBidDocument: '/ygsjzs/ycBidDocument/addYcBidDocument',
  // 供应商报名
  updateYcBidSupplier: '/ygsjzs/ycBidDocument/updateYcBidSupplier',
  // 查询供应商报名详情
  selectYcBidSupplierByRelId: '/ygsjzs/ycBidDocument/selectYcBidSupplierByRelId',
  // 删除标书管理
  deleteYcBidDocument: '/ygsjzs/ycBidDocument/deleteYcBidDocument',
  // 查询标书管理详情
  selectYcBidDocumentByBidId: '/ygsjzs/ycBidDocument/selectYcBidDocumentByBidId',
  // 数字统计/分页查询标书管理列表
  selectYcBidDocumentCount: '/ygsjzs/ycBidDocument/selectYcBidDocumentCount',
  // 分页查询标书管理列表
  selectYcBidDocumentByPage: '/ygsjzs/ycBidDocument/selectYcBidDocumentByPage'

}
